import { Settlement } from '../../../models/Entities/Settlements/Settlement';
import { SettlementUpdateCommand } from '../../../models/Entities/Settlements/SettlementUpdateCommand';

export const NAME_MAX_LENGTH = 120;

/**
 * Arma el comando de actualización a partir de la liquidación tal como está,
 * cambiando sólo lo que se pide. El API espera el objeto completo, no un parche.
 */
export const buildUpdateCommand = (settlement: Settlement, patch: Partial<SettlementUpdateCommand>): SettlementUpdateCommand => {
    const source = settlement as Settlement & Record<string, any>;
    const command: SettlementUpdateCommand = {
        id: settlement.id,
        name: settlement.name,
        description: settlement.description ?? null,
        protocolId: source.protocolId ?? settlement.protocol?.[0]?.protocolId ?? null,
        practitionerId: source.practitionerId ?? settlement.practitioner?.[0]?.practitionerId ?? null,
        medicalInsuranceId: source.medicalInsuranceId ?? null,
        medicalAgreementId: source.medicalAgreementId ?? settlement.agreements?.[0]?.medicalAgreementId ?? null,
        contractId: source.contractId ?? settlement.contract?.[0]?.contractId ?? null,
        settlementType: settlement.settlementType,
        status: settlement.status,
        currencyCode: settlement.currencyCode ?? null,
        settlementDateRangeInit: settlement.settlementDateRangeInit ?? null,
        settlementDateRangeEnd: settlement.settlementDateRangeEnd ?? null,
        isLastSettlement: source.isLastSettlement ?? false,
        isManualSettlement: settlement.isManualSettlement ?? false,
        isIncludeContractConcepts: source.isIncludeContractConcepts ?? false,
        isIncludedAdditionalConcepts: source.isIncludedAdditionalConcepts ?? false,
        isIncludedRefundableConcepts: source.isIncludedRefundableConcepts ?? false
    };
    return { ...command, ...patch };
};

/** Qué está mal con el nombre, o nada. */
export const validateName = (name: string, current: string | undefined): string | undefined => {
    const trimmed = (name || '').trim();
    if (!trimmed) return 'El nombre no puede quedar vacío.';
    if (trimmed.length > NAME_MAX_LENGTH) return `Como máximo ${NAME_MAX_LENGTH} caracteres.`;
    if (trimmed === (current || '').trim()) return 'Es el mismo nombre que tiene ahora.';
    return undefined;
};
